import { Box, Chip } from "@mui/material";
import { ContentLengthOptions } from "../../enums/ContentLengthOptions";

export const TIP_LENGTH_THRESHOLD = {
  [ContentLengthOptions.MEDIUM]: 150,
  [ContentLengthOptions.LONG]: 299,
};

const TipLength = ({ numberOfWords }: { numberOfWords: number }) => {
  const getWordCountChipColor = () => {
    if (numberOfWords >= TIP_LENGTH_THRESHOLD[ContentLengthOptions.LONG]) {
      return "success";
    }

    if (numberOfWords >= TIP_LENGTH_THRESHOLD[ContentLengthOptions.MEDIUM]) {
      return "primary";
    }

    return "error";
  };

  const getWordCountLabel = () => {
    if (numberOfWords >= TIP_LENGTH_THRESHOLD[ContentLengthOptions.LONG]) {
      return "Long Tip";
    }

    if (numberOfWords >= TIP_LENGTH_THRESHOLD[ContentLengthOptions.MEDIUM]) {
      return "Medium Tip";
    }

    return "Short Tip";
  };

  return (
    <Box className="d-flex align-items-center gap-2">
      <Chip
        label={`${numberOfWords} words`}
        color={getWordCountChipColor()}
        size="small"
        variant="outlined"
      />
      <Chip
        label={getWordCountLabel()}
        color={getWordCountChipColor()}
        size="small"
      />
    </Box>
  );
};

export default TipLength;
